export function clampUsageProgressPercent(usagePercent: number): number {
    return Math.min(Math.max(usagePercent, 0), 100);
}

/** One decimal place so small holds on large pools do not round to 0%. */
export function formatUsageSharePercent(usage: number, total: number): string {
    const share = total > 0 ? (Math.max(usage, 0) / total) * 100 : 0;
    return `${share.toFixed(1)}%`;
}
